export default __webpack_public_path__ + "static/media/add_services02.0fa164dc.webp";